$(window).on("load", function(){
    window.requestAnimationFrame(function() {
        var tl = new TimelineLite();
        tl.staggerTo(".toes", 0.15, {y:10}, 0.1);
        tl.to(".toes", 0.2, {y:0});

        tl.to(".heart", 0.32, {scale:1.15, ease:Back.easeInOut.config(2)},'-=.25' );
        tl.to(".heart", 0.2, {scale:1});

        tl.fromTo(".lyl", .35, {y:-40} , {y:0, opacity:1});
        tl.fromTo(".a-pad-awareness", .25, {y:20}, {y:0, opacity:1} , '-=.25');
    });
});